import styled from 'styled-components';

export const Container = styled.div`
    height: 0.25rem;
    width: 100%;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 2px;
`;

export const Progress = styled.div`
    height: 0.25rem;
    background-color: ${({ theme }) => theme.colors.bgSecondary};
    border-radius: 2px;
`;
